import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

/**
 * Service de configuration PrimeNG
 * Note: PrimeNG 19 utilise une configuration différente
 * Les traductions sont gérées via les fichiers i18n
 */
@Injectable({
  providedIn: 'root',
})
export class PrimeNGConfigService {
  private readonly translate = inject(TranslateService);

  initialize(): void {
    // PrimeNG 19 configuration
    // Les traductions sont gérées via les fichiers i18n standard
    // Le ripple effect est activé par défaut dans PrimeNG 19
  }
}

